import { render, staticRenderFns } from "./ComercialTable.vue?vue&type=template&id=dd4fd034"
import script from "./ComercialTable.vue?vue&type=script&lang=js"
export * from "./ComercialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports